<app-page-header>
    {{ 'Communities' }}
    <a *ngIf="dataTable.hasData"
       mat-fab extended disableRipple color="primary"
       [attr.aria-label]="routerAddButton.ariaLabel"
       [routerLink]="routerAddButton.route">
        <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
        {{ routerAddButton.label }}
    </a>
</app-page-header>

<app-table #dataTable
           class="pmc-organizations-table"
           [columnMap]="columnMap"
           [columnSort]="columnSort"
           [type]="tableType"
           [rowSelectable]="true"
           (rowSelect)="goToOrganization($event)"
           (showFilters)="openFilters($event)"
           matSort
           matSortActive="name"
           matSortDirection="asc"
           matSortDisableClear="true">
    <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[0].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="[row.id, 'details']" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.id }} | {{ row.unitsCount || 0 | i18nPlural: unitsMapping }}</span>
                <mat-chip-set [attr.aria-label]="'test mode'">
                    <mat-chip *ngIf="row.demo"
                              class="test-mode-chip"
                              highlighted
                              animated
                              disableRipple>
                        <span>{{ 'Test Data' }}</span>
                    </mat-chip>
                </mat-chip-set>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnMap[1].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.name">
            <app-avatar-block [initials]="row.initials">
                <a [routerLink]="[row.id, 'details']" avatarTitle>{{ row.name }}</a>
                <span avatarDescription>{{ row.id }} | {{ row.unitsCount || 0 | i18nPlural: unitsMapping }}</span>
                <mat-chip *ngIf="row.demo"
                          class="test-mode-chip"
                          highlighted
                          animated
                          disableRipple>
                    <span>{{ 'Test Data' }}</span>
                </mat-chip>
            </app-avatar-block>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="admins">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[2].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.admins">
            <span>
                <ng-container *ngFor="let admin of row.admins; let isLast = last">
                    <span class="no-wrap" [innerHTML]="admin.profile?.givenNames + ' ' + admin.profile?.familyName + (!isLast ? ',' : '')"></span>
                </ng-container>
            </span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="address">
        <mat-header-cell *matHeaderCellDef>{{ columnMap[3].title }}</mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.profile.address1">
            <span [innerHTML]="row.profile | addressLine"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="openSubmissionsCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell>
            <span class="no-wrap">{{ columnMap[4].title }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.openSubmissionsCount" useZero="true" numberCell>
            {{ row.openSubmissionsCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="openViolationsCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" numberCell>
            <span class="no-wrap">{{ columnMap[5].title }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [emptyCell]="!row.openViolationsCount" useZero="true" numberCell>
            {{ row.openViolationsCount | number:'1.0':'en-US' }}
        </mat-cell>
    </ng-container>

    <app-empty-state [icon]="'communities'">
        <span emptyStateTitle>{{ 'No communities so far...' }}</span>
        <a mat-fab extended disableRipple color="primary"
           [attr.aria-label]="routerAddButton.ariaLabel"
           [routerLink]="routerAddButton.route"
           [queryParams]="routerAddButton?.queryParams">
            <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
            {{ routerAddButton.label }}
        </a>
    </app-empty-state>
</app-table>
